var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{attrs:{"for":"agreeTerms"}},[_c('a',{staticClass:"text-theme-1 ml-1 dark:text-gray-200",attrs:{"href":_vm.terms}},[_vm._v("Privcy Policy")]),_c('a',{staticClass:"text-theme-1 ml-10 dark:text-gray-200",attrs:{"href":_vm.privacy}},[_vm._v("Terms of Service")])])
}
var staticRenderFns = []

export { render, staticRenderFns }